/* ==========================================================================
   OliveDrab — Stories, Woven In
   Faces glide along the thread, the story in front plays muted, its words
   reveal line by line, and a thread ties the garment to her look.
   Everything a visitor reads is already in the page; this only moves it.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function ease(t) { return 1 - Math.pow(1 - t, 4); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function clock(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function setup(root) {
    if (root.dataset.odStBound) return;
    root.dataset.odStBound = '1';

    var wrap = $('[data-od-st-wrap]', root);
    var main = $('[data-od-st-main]', root);
    var screen = $('[data-od-st-screen]', root);
    var films = $$('[data-od-st-film]', root);
    var cards = $$('[data-od-st-card]', root);
    var faces = $$('[data-od-st-face]', root);
    var capsules = $$('[data-od-st-capsule]', root);
    var path = $('[data-od-st-path]', root);
    var drawn = $('[data-od-st-drawn]', root);
    var spool = $('[data-od-st-spool]', root);
    var tie = $('[data-od-st-tie]', root);
    var tiePath = $('[data-od-st-tie-path]', root);
    var tieEnd = $('[data-od-st-tie-end]', root);
    var peek = $('[data-od-st-peek]', root);
    var peekVideo = $('[data-od-st-peek-video]', root);
    var live = $('[data-od-st-live]', root);
    var toggleBtn = $('[data-od-st-toggle]', root);
    var soundBtn = $('[data-od-st-sound]', root);
    var timeEl = $('[data-od-st-time]', root);
    var scrub = $('[data-od-st-scrub]', root);
    var scrubFill = $('[data-od-st-scrub-fill]', root);
    var nowEl = $('[data-od-st-now]', root);
    var progress = $('[data-od-st-progress]', root);

    var total = films.length;
    if (!total) return;

    var autoplay = root.dataset.autoplay !== 'false';
    var advance = root.dataset.advance !== 'false';
    var maxMs = num(root.dataset.maxSeconds, 30) * 1000;
    var speed = num(root.dataset.speed, 900);
    var hotspotDelay = num(root.dataset.hotspotDelay, 1500);
    var countLabel = root.dataset.countLabel || 'Story';

    var desk = window.matchMedia('(min-width: 750px)');
    var active = 0;
    var pos = 0;           // where the faces are along the thread, as a float index
    var anim = null;
    var onScreen = false;
    var userPaused = false;
    var muted = true;
    var holdTimer = null;
    var tagTimer = null;
    var waveRaf = null;

    /* ------------------------------------------------ the thread path */

    var pathLen = path && path.getTotalLength ? path.getTotalLength() : 0;
    var focusLen = 0;
    if (pathLen) {
      // the point on the curve closest to x = 560 is where the active face sits
      var best = Infinity;
      for (var l = 0; l <= pathLen; l += pathLen / 200) {
        var p = path.getPointAtLength(l);
        var d = Math.abs(p.x - 560) + Math.abs(p.y - 145) * 0.2;
        if (d < best) { best = d; focusLen = l; }
      }
      if (drawn) {
        drawn.style.strokeDasharray = pathLen + ' ' + pathLen;
      }
    }

    function placeFaces() {
      if (!pathLen || !desk.matches) {
        faces.forEach(function (f) { f.style.left = ''; f.style.top = ''; f.style.opacity = ''; f.classList.remove('is-left'); });
        return;
      }
      var W = wrap.clientWidth, H = wrap.clientHeight;
      var gap = pathLen * 0.15;
      faces.forEach(function (f, i) {
        var d = i - pos;
        // wrap into the shortest way round
        while (d > total / 2) d -= total;
        while (d < -total / 2) d += total;
        var len = focusLen + d * gap;
        var clamped = Math.max(pathLen * 0.06, Math.min(pathLen * 0.99, len));
        var pt = path.getPointAtLength(clamped);
        // names read away from the story: to the left of faces left of centre
        f.classList.toggle('is-left', d < -0.5);
        f.style.left = (pt.x / 1000 * W) + 'px';
        f.style.top = (pt.y / 1000 * H) + 'px';
        var edge = Math.abs(d);
        var off = len < pathLen * 0.06 || len > pathLen * 0.99;
        f.style.opacity = off || edge > 2.4 ? '0' : (edge > 2 ? String(1 - (edge - 2) / 0.4) : '1');
        f.style.pointerEvents = off || edge > 2.2 ? 'none' : '';
      });
      if (drawn) {
        // the stitched part of the thread grows with each story seen
        var share = (active + 1) / total;
        drawn.style.strokeDashoffset = String(pathLen * (1 - share));
      }
    }

    function glideTo(target) {
      if (anim) cancelAnimationFrame(anim);
      var from = pos;
      var delta = target - from;
      while (delta > total / 2) delta -= total;
      while (delta < -total / 2) delta += total;
      if (reduced() || !desk.matches) { pos = target; placeFaces(); return; }
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var k = Math.min(1, (ts - start) / speed);
        pos = from + delta * ease(k);
        placeFaces();
        if (k < 1) anim = requestAnimationFrame(step);
        else { pos = ((target % total) + total) % total; placeFaces(); anim = null; }
      }
      anim = requestAnimationFrame(step);
    }

    /* ------------------------------------------ the words, line by line */

    function buildLines(card) {
      var words = $('[data-od-st-words]', card);
      if (!words) return;
      if (!words.dataset.source) words.dataset.source = words.innerHTML;
      var html = words.dataset.source;
      var paras = html.split(/<br\s*\/?>/i);
      words.innerHTML = '';
      var spans = [];
      paras.forEach(function (para, pi) {
        var tmp = document.createElement('div');
        tmp.innerHTML = para;
        var text = tmp.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        text.split(' ').forEach(function (w) {
          var sp = document.createElement('span');
          sp.textContent = w + ' ';
          sp.style.display = 'inline';
          words.appendChild(sp);
          spans.push({ el: sp, para: pi });
        });
      });
      // group words by the line they landed on
      var lines = [];
      var lastTop = null, lastPara = null;
      spans.forEach(function (s) {
        var top = s.el.offsetTop;
        if (lastTop === null || Math.abs(top - lastTop) > 3 || s.para !== lastPara) {
          lines.push([]);
          lastTop = top;
          lastPara = s.para;
        }
        lines[lines.length - 1].push(s.el.textContent);
      });
      words.innerHTML = '';
      lines.forEach(function (ln, i) {
        var line = document.createElement('span');
        line.className = 'od-st__line';
        line.style.setProperty('--i', i);
        line.textContent = ln.join('').replace(/\s+$/, '');
        words.appendChild(line);
        if (i < lines.length - 1) words.appendChild(document.createElement('br'));
      });
      words.dataset.built = String(words.clientWidth);
    }

    function ensureLines(card, force) {
      var words = $('[data-od-st-words]', card);
      if (!words) return;
      if (force || words.dataset.built !== String(words.clientWidth)) buildLines(card);
    }

    /* ------------------------------------------------------- the films */

    function videoOf(i) { return films[i] ? $('[data-od-st-video]', films[i]) : null; }

    function load(v) {
      if (v && !v.getAttribute('src') && v.dataset.src) {
        v.setAttribute('src', v.dataset.src);
        v.preload = 'metadata';
      }
    }

    function unload(v) {
      if (!v) return;
      try { v.pause(); } catch (e) {}
    }

    function wantPlay() {
      return autoplay && onScreen && !userPaused && !reduced() && !document.hidden;
    }

    function syncToggle(playing) {
      if (!toggleBtn) return;
      $('[data-od-st-ico-pause]', toggleBtn).hidden = !playing;
      $('[data-od-st-ico-play]', toggleBtn).hidden = playing;
      toggleBtn.setAttribute('aria-label', playing ? toggleBtn.dataset.labelPause : toggleBtn.dataset.labelPlay);
    }

    function play() {
      var v = videoOf(active);
      if (!v) { syncToggle(false); return; }
      load(v);
      v.muted = muted;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { syncToggle(false); });
    }

    function pause() {
      var v = videoOf(active);
      if (v) try { v.pause(); } catch (e) {}
    }

    function refreshPlayback() {
      if (wantPlay()) play(); else pause();
    }

    /* the waveform moves with the film, calmer when muted, still when paused */
    function wave() {
      var card = cards[active];
      var bars = card ? $$('[data-od-st-wave] i', card) : [];
      var v = videoOf(active);
      var playing = v && !v.paused && !v.ended;
      var t = v ? v.currentTime : 0;
      bars.forEach(function (b, i) {
        var h;
        if (!playing) h = 3 + ((i * 7) % 5);
        else {
          var amp = v.muted ? 7 : 16;
          h = 3 + amp * Math.abs(Math.sin(t * (2.1 + (i % 5) * 0.37) + i * 0.9)) * (0.55 + 0.45 * Math.abs(Math.sin(t * 0.8 + i)));
        }
        b.style.height = h.toFixed(1) + 'px';
      });
      if (timeEl && v) timeEl.textContent = clock(v.currentTime) + ' / ' + clock(v.duration);
      if (scrubFill && v && v.duration) scrubFill.style.width = (v.currentTime / v.duration * 100) + '%';
      waveRaf = playing ? requestAnimationFrame(wave) : null;
    }

    function startWave() { if (!waveRaf) waveRaf = requestAnimationFrame(wave); }

    /* ------------------------------------------ the thread to the look */

    function drawTie() {
      if (!tie || !tiePath || !desk.matches) return;
      var film = films[active];
      var card = cards[active];
      var dot = film && $('[data-od-st-hotspot]', film);
      var look = card && $('[data-od-st-look]', card);
      if (!dot || !look || !film.classList.contains('is-tagged')) { tie.classList.remove('is-on'); return; }
      var box = main.getBoundingClientRect();
      var a = dot.getBoundingClientRect();
      var b = look.getBoundingClientRect();
      var x1 = a.left + a.width / 2 - box.left, y1 = a.top + a.height / 2 - box.top;
      var x2 = b.left - box.left, y2 = b.top + b.height / 2 - box.top;
      var mx = (x1 + x2) / 2;
      tiePath.setAttribute('d', 'M' + x1 + ' ' + y1 + ' C ' + mx + ' ' + y1 + ', ' + (mx - 20) + ' ' + y2 + ', ' + x2 + ' ' + y2);
      if (tieEnd) { tieEnd.setAttribute('cx', x2); tieEnd.setAttribute('cy', y2); }
      var len = tiePath.getTotalLength ? tiePath.getTotalLength() : 0;
      if (len && !reduced()) {
        tiePath.style.transition = 'none';
        tiePath.style.strokeDashoffset = String(len);
        tiePath.getBoundingClientRect();
        tiePath.style.transition = 'stroke-dashoffset 900ms cubic-bezier(0.22, 1, 0.36, 1), opacity 400ms ease';
        tiePath.style.strokeDashoffset = '0';
      }
      tie.classList.add('is-on');
    }

    /* ------------------------------------------------------- the peek */

    function updatePeek() {
      if (!peekVideo || total < 2) return;
      var next = videoOf((active + 1) % total);
      var src = next ? next.dataset.src : '';
      if (src && peekVideo.getAttribute('src') !== src) {
        peekVideo.setAttribute('src', src);
        peekVideo.preload = 'metadata';
      }
    }

    /* ------------------------------------------------------ go to a story */

    function go(i, announce) {
      i = ((i % total) + total) % total;
      var prev = active;
      clearTimeout(holdTimer);
      clearTimeout(tagTimer);
      if (i !== prev) {
        var old = videoOf(prev);
        if (old) { unload(old); try { old.currentTime = 0; } catch (e) {} }
      }
      active = i;

      films.forEach(function (f, n) {
        var on = n === i;
        f.classList.toggle('is-active', on);
        f.classList.remove('is-tagged');
        if (on) f.removeAttribute('aria-hidden'); else f.setAttribute('aria-hidden', 'true');
        var hs = $('[data-od-st-hotspot]', f);
        if (hs) hs.tabIndex = on ? 0 : -1;
      });
      cards.forEach(function (c, n) {
        var on = n === i;
        if (on) { ensureLines(c); c.removeAttribute('aria-hidden'); }
        else c.setAttribute('aria-hidden', 'true');
        // restart the line reveal
        if (on && !reduced()) {
          c.classList.remove('is-active');
          c.getBoundingClientRect();
        }
        c.classList.toggle('is-active', on);
      });
      faces.forEach(function (f, n) {
        f.classList.toggle('is-active', n === i);
        f.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      capsules.forEach(function (c, n) {
        var on = n === i && c.hasAttribute('href');
        c.hidden = !on;
        c.classList.toggle('is-active', on);
      });

      if (nowEl) nowEl.textContent = pad(i + 1);
      if (progress) progress.style.width = ((i + 1) / total * 100) + '%';
      if (spool && !reduced()) spool.style.transform = 'rotate(' + (i * 32) + 'deg)';
      if (tie) tie.classList.remove('is-on');
      if (announce && live) live.textContent = countLabel + ' ' + (i + 1) + ' / ' + total;

      glideTo(i);
      updatePeek();

      var v = videoOf(i);
      if (v) load(v);
      refreshPlayback();
      startWave();

      tagTimer = setTimeout(function () {
        if (films[i]) films[i].classList.add('is-tagged');
        drawTie();
      }, reduced() ? 0 : hotspotDelay);

      if (total > 1 && advance && !reduced()) {
        holdTimer = setTimeout(function () { if (onScreen && !userPaused) go(active + 1, true); }, maxMs);
      }
    }

    /* ------------------------------------------------------ controls */

    films.forEach(function (f, n) {
      var v = $('[data-od-st-video]', f);
      if (!v) return;
      v.addEventListener('play', function () { if (n === active) { syncToggle(true); startWave(); } });
      v.addEventListener('pause', function () { if (n === active) syncToggle(false); });
      v.addEventListener('loadedmetadata', function () { if (n === active) wave(); });
      v.addEventListener('ended', function () {
        if (n !== active) return;
        if (total > 1 && advance && !reduced()) go(active + 1, true);
        else { try { v.currentTime = 0; } catch (e) {} if (wantPlay()) play(); }
      });
      var hs = $('[data-od-st-hotspot]', f);
      if (hs) hs.addEventListener('click', function () {
        drawTie();
        var look = $('[data-od-st-look]', cards[n]);
        var cta = look && $('.od-st__look-cta', look);
        if (desk.matches && cta) { cta.focus({ preventScroll: true }); }
        var cap = capsules[n];
        if (!desk.matches && cap && !cap.hidden) cap.focus();
      });
    });

    if (toggleBtn) toggleBtn.addEventListener('click', function () {
      var v = videoOf(active);
      if (!v) return;
      if (v.paused) { userPaused = false; load(v); v.muted = muted; v.play(); }
      else { userPaused = true; v.pause(); }
    });

    if (soundBtn) soundBtn.addEventListener('click', function () {
      muted = !muted;
      var v = videoOf(active);
      if (v) { v.muted = muted; if (!muted && v.paused) { userPaused = false; load(v); v.play(); } }
      soundBtn.setAttribute('aria-pressed', String(!muted));
      $('[data-od-st-ico-mute]', soundBtn).hidden = !muted;
      $('[data-od-st-ico-sound]', soundBtn).hidden = muted;
      startWave();
    });

    if (scrub) scrub.addEventListener('click', function (e) {
      var v = videoOf(active);
      if (!v || !v.duration) return;
      var r = scrub.getBoundingClientRect();
      v.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * v.duration;
      wave();
    });

    faces.forEach(function (f) {
      f.addEventListener('click', function () {
        userPaused = false;
        go(parseInt(f.dataset.odStFace, 10), true);
      });
    });

    var prevBtn = $('[data-od-st-prev]', root);
    var nextBtn = $('[data-od-st-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1, true); });
    if (peek) peek.addEventListener('click', function () { go(active + 1, true); });

    main.addEventListener('keydown', function (e) {
      if (e.target !== main) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1, true); }
    });

    /* swipe across the film */
    var sx = null, sy = null;
    screen.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      sx = e.clientX; sy = e.clientY;
    });
    screen.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.2) go(active + (dx < 0 ? 1 : -1), true);
    });
    screen.addEventListener('pointercancel', function () { sx = null; });
    // touch fallback for browsers that cancel pointer events while panning
    screen.addEventListener('touchstart', function (e) {
      if (e.target.closest('button')) return;
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY;
    }, { passive: true });
    screen.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.2) go(active + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    /* --------------------------------------------- in view, tab, resize */

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { onScreen = en.isIntersecting; });
        if (onScreen) { ensureLines(cards[active]); placeFaces(); updatePeek(); }
        refreshPlayback();
        startWave();
      }, { threshold: 0.2 }).observe(root);
    } else {
      onScreen = true;
    }

    document.addEventListener('visibilitychange', refreshPlayback);

    var resizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        placeFaces();
        ensureLines(cards[active]);
        if (films[active] && films[active].classList.contains('is-tagged')) drawTie();
      }, 120);
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(function () { placeFaces(); }).observe(wrap);
    }

    // overflow hidden can still be scrolled by focus; keep the section still
    root.addEventListener('scroll', function () { if (root.scrollLeft) root.scrollLeft = 0; });

    root.classList.add('is-ready');
    cards.forEach(function (c) { ensureLines(c, true); });
    go(0, false);
  }

  function boot(scope) {
    $$('[data-od-st]', scope || document).forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
